import React, { useCallback, useEffect, useState } from "react";
import { LoadingIcon } from 'components/Icons';
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { BASE_GUTTER } from 'constants/Layout';
import DescriptionItem from 'views/Inventory/DescriptionItem';
import { Spin, Row, Col } from 'antd';
import { CellRenderers } from "utils/tableUtils";

const AssessmentContent = ({ toolName, loginId, assetId }) => {
    const [loading, setLoading] = useState(true);
    const [assessmentData, setAssessmentData] = useState({});

    const fetchAssessmentData = useCallback(() => {
        setLoading(true)
        const { promise, cancel } = ToolsIntegrationsAPI.getAssessmentDetail(toolName, loginId, assetId);

        promise
            .then(setAssessmentData)
            .catch(console.error)
            .finally(() => setLoading(false))

        return cancel;
    }, [toolName, loginId, assetId])

    useEffect(fetchAssessmentData, [fetchAssessmentData]);

    return <Spin spinning={loading} indicator={<LoadingIcon />}>
        <Row gutter={BASE_GUTTER}>
            <Col>
                <DescriptionItem title="Last DAST Scan" content={CellRenderers.TIME(assessmentData.lastDastScanDate)} />
            </Col>
        </Row>
        <Row gutter={BASE_GUTTER}>
            <Col>
                <DescriptionItem title="Next DAST Scan" content={CellRenderers.TIME(assessmentData.nextDastScanDate)} />
            </Col>
        </Row>
        <Row gutter={BASE_GUTTER}>
            <Col>
                <DescriptionItem title="Last Pen Test" content={CellRenderers.TIME(assessmentData.lastPenTestScanDate)} />
            </Col>
        </Row>
        <Row gutter={BASE_GUTTER}>
            <Col>
                <DescriptionItem title="Next Pen Test" content={CellRenderers.TIME(assessmentData.nextPenTestScanDate)} />
            </Col>
        </Row>
    </Spin>
}

export default AssessmentContent;